const env = (import.meta.env as Record<string, string | undefined> | undefined) ?? {};
const envUrl = typeof env.VITE_SITE_URL === 'string' ? env.VITE_SITE_URL.trim() : '';

export const SITE_ORIGIN = (
  envUrl || (typeof window !== 'undefined' ? window.location.origin : '')
).replace(/\/+$/, '');

export const SITE_NAME = 'AM ESTUDIO';
export const SITE_LOCALE = 'es_MX';

export const DEFAULT_OG_IMAGE =
  'https://static.readdy.ai/image/45c2ae79549b129e69766d02f53aa268/91a18eff723db5a8d80b3a2a7d0dc9ee.png';

export function absoluteUrl(path: string): string {
  if (!path || path === '/') return `${SITE_ORIGIN}/`;
  const clean = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_ORIGIN}${clean}`;
}